export default __webpack_public_path__ + "static/app-5-4f217a3022d915a49c1773607f9bbfd4.webp";